import React from 'react';
import './project-schedule-dates.css';

const defaults = [
  { id: 'install_start', label: 'Install Start' },
  { id: 'install_end', label: 'Install End' },
  { id: 'delivery_date', label: 'Delivery Date' },
];

export const projectDateEntries = (job, schema = []) => {
  const metadata = [...(job.date_fields || []), ...schema];
  const entries = defaults.map(field => {
    const definition = metadata.find(item => item.id === field.id) || field;
    return { ...field, ...definition, value: job[field.id] };
  });
  (job.custom_fields || []).filter(field => ['date', 'datetime'].includes(field.type))
    .forEach(field => entries.push(field));
  return entries.filter(field => typeof field.value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(field.value))
    .sort((a, b) => a.value.localeCompare(b.value));
};

export const formatScheduleDate = ({ value, type }) => {
  const dateOnly = type === 'date' || !value.includes('T');
  const date = new Date(dateOnly ? `${value.slice(0, 10)}T00:00:00` : value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric',
    ...(dateOnly ? {} : { hour: 'numeric', minute: '2-digit' }),
  });
};

export const ProjectScheduleDates = ({ job, schema }) => {
  const entries = projectDateEntries(job, schema);
  return <div className="schedule-date-fields" data-testid={`schedule-dates-${job.id}`}>
    {entries.length ? entries.map(field => <div className="schedule-date-field" key={field.id}
      data-testid={`schedule-date-${job.id}-${field.id}`}>
      <span className="schedule-date-label">{field.label}</span>
      <time dateTime={field.value}>{formatScheduleDate(field)}</time>
    </div>) : <span data-testid={`schedule-unscheduled-${job.id}`}>Unscheduled</span>}
  </div>;
};